<template>
  <b-card class="mb-2">
    <b-form @submit="onSubmit">
      <b-form-input
        id="input-subject"
        v-model="form.subject"
        placeholder="Enter subject(Optional)"
      ></b-form-input>

      <b-form-textarea
        id="input-message"
        v-model="form.message"
        placeholder="Enter something..."
        required
        rows="3"
        max-rows="3"
        maxlength="4096"
      ></b-form-textarea>

      <b-button type="submit" variant="outline-primary" size="sm">Submit</b-button>
    </b-form>
  </b-card>
</template>

<script>
import Filter from 'bad-words';
const filter = new Filter();

export default {
  data() {
    return {
      form: {
        subject: '',
        message: '',
      },
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.form.subject = filter.clean(this.form.subject);
      this.form.message = filter.clean(this.form.message);
      this.$emit('EventNewMessageData', this.form);
      this.form.subject = '';
      this.form.message = '';
    },
  },
};
</script>
